import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ConnectedCmpListPayload,
  ConnectedCmpListResults,
  GetCmpMailboxesPayload,
  GetCmpMailboxesResult,
  GetCmpSequencesResult,
  GetInstantlySequencesPayload,
  SaveDataToCmpPayload,
} from './types';
import { apiClient } from 'src/api/apiClient';
import {
  GET_CMP_MAILBOXES,
  GET_CONNECTED_CMP_LIST,
  GET_CRM_SEQUENCES,
  GET_CUSTOMER_ID,
  SAVE_DATA_TO_CMP,
  get_SEQUENCES_FROM_CMPS,
} from 'src/constants/httpEndPoints';

export const getConnectedCmpList = createAsyncThunk<
  ConnectedCmpListResults,
  ConnectedCmpListPayload
>('runCampaign/getConnectedCmpList', async ({ emailId, customerId, controller }) => {
  const { data: numericCustomerId } = await apiClient.get(
    `${GET_CUSTOMER_ID}?uniqueId=${customerId}`,
  );
  const res = await apiClient.get(
    `${GET_CONNECTED_CMP_LIST}?customer=${numericCustomerId}&emailId=${emailId}`,
    {
      signal: controller?.signal,
    },
  );

  return res.data || [];
});

export const getCmpMailboxes = createAsyncThunk<GetCmpMailboxesResult, GetCmpMailboxesPayload>(
  'runCampaign/getCmpMailboxes',
  async ({ customerId, emailId, providerName }) => {
    const res = await apiClient.get(
      `${GET_CMP_MAILBOXES}?customer_id=${customerId}&integration_type=${providerName}&email=${emailId}`,
    );

    return res.data?.mailboxes || [];
  },
);

export const getCmpSequences = createAsyncThunk<GetCmpSequencesResult, GetCmpMailboxesPayload>(
  'runCampaign/getCmpSequences',
  async ({ customerId, emailId, providerName ,userFilterEnabled }) => {
    const res = await apiClient.get(
      `${GET_CRM_SEQUENCES}/cusId/${customerId}/source/${providerName}?email=${emailId}&userFilterEnabled=${userFilterEnabled}`,
    );

    return res.data || [];
  },
);

export const getInstantlySequences = createAsyncThunk<
  GetCmpSequencesResult,
  GetInstantlySequencesPayload
>('runCampaign/getInstantlySequences', async ({ customerId, emailId, providerName, search }) => {
  const res = await apiClient.get(
    get_SEQUENCES_FROM_CMPS(customerId, providerName, emailId, search),
  );

  return res.data || [];
});

export const saveDataToCmp = createAsyncThunk<void, SaveDataToCmpPayload>(
  'runCampaign/saveDataToCmp',
  async (payload) => {
    const { emailId, ...restPayload } = payload;

    await apiClient.post(SAVE_DATA_TO_CMP, restPayload, { headers: { email: emailId } });
  },
);
